import React from "react";
import ProductCard from "./ProductCard";

const SaleProductCard = ({ colors, sale }) => {
  const campaignProduct = {
    points: sale ? sale.quantity : 0,
  };

  return (
    <ProductCard
      className="sale-product-card"
      colors={colors}
      product={sale}
      // Sales posts show a quantity (number of units), not points.
      // Override the default currency label so "unidades" is displayed
      // instead of the campaign's points currency (e.g. gcoins).
      currencyLabel="unidades"
      {...campaignProduct}
    />
  );
};

export default SaleProductCard;
